// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customer-filter[data-v-3a982d58] .el-drawer__body {\n  overflow: auto;\n  padding-bottom: 25px;\n}\n", ""]);
// Exports
module.exports = exports;
